/**
 * Scroll-triggered reveal animations using IntersectionObserver.
 * Add data-reveal="fade-up|fade-in|fade-left|fade-right" to any element.
 * Optional: data-reveal-delay="200" (ms) for staggered reveals.
 */
(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init() {
        const elements = document.querySelectorAll('[data-reveal]');
        if (!elements.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;

                    const el = entry.target;
                    const delay = parseInt(el.dataset.revealDelay, 10) || 0;

                    if (delay) {
                        setTimeout(() => el.classList.add('revealed'), delay);
                    } else {
                        el.classList.add('revealed');
                    }

                    observer.unobserve(el);
                });
            },
            { threshold: 0.05 }
        );

        elements.forEach((el) => observer.observe(el));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/**
 * Hero entrance animations — triggered on DOMContentLoaded, not scroll.
 * Add data-hero + data-hero-delay="ms" to elements above the fold.
 */
(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function initHero() {
        document.querySelectorAll('[data-hero]').forEach((el) => {
            const delay = parseInt(el.dataset.heroDelay, 10) || 0;
            setTimeout(() => el.classList.add('revealed'), delay);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHero);
    } else {
        initHero();
    }
})();
